import {BLUR_RADIUS, BORDER_WIDTH} from '../../../spotlight/libs';

export const Blur = ({active = false, edit = false, scale = 1}) => {
  if (active) {
    return (
      <div
        className="absolute box-border size-full rounded-md border-4 border-dashed shadow-md"
        style={{backdropFilter: `blur(${BLUR_RADIUS}px`}}
      >
        <div className="absolute top-[-7px] left-[-7px] size-2.5 cursor-nw-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute top-[-7px] left-1/2 size-2.5 -translate-x-1/2 cursor-n-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute top-[-7px] right-[-7px] size-2.5 cursor-ne-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute top-1/2 right-[-7px] size-2.5 -translate-y-1/2 cursor-e-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute bottom-[-7px] left-[-7px] size-2.5 cursor-sw-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute bottom-[-7px] left-1/2 size-2.5 -translate-x-1/2 cursor-s-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute right-[-7px] bottom-[-7px] size-2.5 cursor-se-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
        <div className="absolute top-1/2 left-[-7px] size-2.5 -translate-y-1/2 cursor-e-resize rounded-full border-2 border-[#1e253b] bg-bg-secondary" />
      </div>
    );
  }

  if (edit) {
    return (
      <div
        className="absolute box-border size-full rounded-md border-4 border-dashed shadow-md"
        style={{
          backdropFilter: `blur(${BLUR_RADIUS}px`,
          borderRadius: BORDER_WIDTH / scale,
        }}
      />
    );
  }

  return (
    <div
      className="absolute size-full rounded-md"
      style={{
        backdropFilter: `blur(${BLUR_RADIUS}px`,
        borderRadius: BORDER_WIDTH / scale,
      }}
    />
  );
};
